export enum CommonColors {
  Default = `var(--default, #243443)`,
  DefaultLight = "var(--default-light, #F7F7F9)",
  DefaultDark = "var(--default-dark, #AAB0B7)",
  Primary = "var(--primary, #5A52C3)",
  Selected = "var(--selected, #5A52C3)",
  PrimaryLight = "var(--primary-light,#E6E4FF)",
  PrimaryDark = "var(--primary-dark, #651FAF)",
  White = "var(--white, #FFFFFF)",
  IconBackground = "var(--icon-background,#E8E7F7)",
  TextMain = "var(--default, #243443)",
  SelectedBg = "var(--selected-bg, #E4E2ED)",
  Secondary = "var(--secondary, #8884A3)",
  ClinicTextBackground = "var(--text-box-bg,#F8F8F8)",
  GradLight = "var(--grad-light,#9F99EA)",
  GradDark = "var(--grad-dark,#5A52C3)",
  RagIcons = "var(--rag-icons, rgba(0, 0, 0, 0.54))",
}
